export default __webpack_public_path__ + "static/media/dubai-world-central.e049b76a.png";